import './index.less'

const prefix = 'page404'
function Page404() {
  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-popup-inner`}>
        <div className={`${prefix}-popup-head`}>
          <div></div>
          <button className={`${prefix}-popup-close`}></button>
        </div>
        <div className={`${prefix}-popup-main`}>
          <span className={`${prefix}-popup-warning`}></span>
          <div>Nongdi dev server. 로그인 후 확인 부탁드립니다.</div>
          <button onClick={() => {
            window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/login/getLoginView.do`
          }} className={`${prefix}-btn-check`}>확인</button>
        </div>
      </div>
    </div>
  )
}
export default Page404
